import { getWindow } from '@acorns/web-utils'

import createEnvironment from 'config/env'

import { FlowProviderActionProps, FlowRoute } from '../../types'
import { DEFAULT_FUNNEL_NAME } from 'utils/FlowProvider/utils'

const environment = createEnvironment()
const webAppUrl = environment.get('webAppUrl')

export const redirectAfterBankLinkSuccess = ({ isEligibleRoundUps }) => {
  return isEligibleRoundUps ? FlowRoute.RoundUpsSetup : FlowRoute.RecurringInvestment
}

export const finishOnboarding = (_, props: FlowProviderActionProps): FlowRoute => {
  if (!props.isRegistrationFlow) {
    getWindow().location.replace(webAppUrl)
    return
  }

  props.setFlow(DEFAULT_FUNNEL_NAME)
  return props.actionName === 'product-onboarding' ? FlowRoute.ProductOnboarding : FlowRoute.HDYHAU
}
